import { Box, Typography, Tooltip } from '@mui/material'

import JavaScript from '../assets/images/skills/js.png'
import Node from '../assets/images/skills/nodejs.png'
import Express from '../assets/images/skills/express.png'
import ReactImg from '../assets/images/skills/reactjs.png'
import MongoDB from '../assets/images/skills/mongodb.png'
import Html from '../assets/images/skills/html.png'
import Css from '../assets/images/skills/CSS.png'
import Git from '../assets/images/skills/git.png'
import Wordpress from '../assets/images/skills/wordpress.png'
import Docker from '../assets/images/skills/docker.png'

const Skills = () => {
  return (
    <>
      <Typography textAlign='center' sx={{ color: '#EDEBF7', marginTop: '5rem' }} variant='h4'>
        <strong style={{ fontStyle: 'italic' }}>My </strong>Skills
      </Typography>
      <Box sx={{
        marginTop: '2rem',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem'
      }}>
        <Tooltip title="JavaScript">
          <img src={JavaScript} alt='js' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="NodeJS">
          <img src={Node} alt='Node' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="ExpressJS">
          <img src={Express} alt='Express' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="React">
          <img src={ReactImg} alt='React' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="MongoDB">
          <img src={MongoDB} alt='MongoDB' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="HTML">
          <img src={Html} alt='HTML' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="CSS">
          <img src={Css} alt='CSS' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="Git">
          <img src={Git} alt='Git' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="Docker">
          <img src={Docker} alt='Docker' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
        <Tooltip title="Wordpress">
          <img src={Wordpress} alt='Wordpress' style={{ maxWidth: 40, objectFit: 'contain' }} />
        </Tooltip>
      </Box>
    </>
  )
}

export default Skills